<form [formGroup]="form" (ngSubmit)="onCreateUpdateSave()">
	<h1 mat-dialog-title class="notification-title">{{ headingKey | translate }}</h1>

	<mat-dialog-content class="mat-dialog-content">
		<div class="dialog-container">
			<mat-form-field appearance="outline" class="dialog">
				@if (controls['layer'].invalid && controls['layer'].touched) {
				<mat-error>{{ 'masterdata.palletising.configuration.dialog.layerParam.errors.validation.layer' | translate }}</mat-error>
				}
				<mat-label class="mat-body-1">{{ 'masterdata.palletising.configuration.layers.layer' | translate }}</mat-label>
				<input OnlyNumbers matInput formControlName="layer" />
			</mat-form-field>
			<mat-form-field appearance="outline" class="dialog">
				@if (controls['maxHeightAfter'].invalid && controls['maxHeightAfter'].touched) {
				<mat-error>{{ 'masterdata.palletising.configuration.dialog.layerParam.errors.validation.maxHeightAfter' | translate }}</mat-error>
				}
				<mat-label class="mat-body-1">{{ 'masterdata.palletising.configuration.layers.maxHeightAfter' | translate }}</mat-label>
				<input OnlyNumbers matInput formControlName="maxHeightAfter" />
			</mat-form-field>

			<mat-form-field appearance="outline" class="dialog">
				@if (controls['maxWeightElement'].invalid && controls['maxWeightElement'].touched) {
				<mat-error>{{ 'masterdata.palletising.configuration.dialog.layerParam.errors.validation.maxWeightElement' | translate }}</mat-error>
				}
				<mat-label class="mat-body-1">{{ 'masterdata.palletising.configuration.layers.maxWeightElement' | translate }}</mat-label>
				<input OnlyNumbers matInput formControlName="maxWeightElement" />
			</mat-form-field>
		</div>
	</mat-dialog-content>

	<mat-dialog-actions align="end">
		<button mat-stroked-button type="button" (click)="onCancel()" (window:keyup.escape)="onCancel()" class="button-border-color">{{ 'general.cancel' | translate }}</button>
		<button mat-flat-button color="primary" type="submit" [disabled]="form.invalid" [ngClass]="{ 'disabled-button': form.invalid }">{{ 'general.ok' | translate }}</button>
	</mat-dialog-actions>
</form>
